export default "__VITE_ASSET__DZB0yDNn__"